<template>
    <v-form-element v-bind="$props">
        <input
            :id="id"
            :type="type"
            :class="className"
            :placeholder="getPlaceholder()"
            v-model="formattedPrice"
            :required="required"
            :disabled="disabled"
            @blur="focusOut"
            @focus="focusIn"
            @click="$emit('click')"
            @hover="$emit('hover')"
        />
    </v-form-element>
</template>

<script>

    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement
        },
        data() {
            return {
                priceInEuros: 0,
                formattedPrice: 0
            }
        },
        methods: {
            focusOut: function() {
                this.priceInEuros = this.formattedPrice;
                this.model = parseFloat(this.priceInEuros.toString().replace(/,/g, '.').replace(/\s/g, '')) * 100;
                
                this.formattedPrice = this.priceInEuros.toLocaleString("fr-FR", {style:"currency", currency:"EUR"});
                
                this.$emit('blur');
                this.$emit('changed');
            },
            focusIn: function() {
                this.formattedPrice = this.priceInEuros;

                this.$emit('focus');
                this.$emit('changed');
            },
            setPriceInEurosFromModel()
            {
                this.priceInEuros = this.model / 100;
                this.formattedPrice = this.priceInEuros.toLocaleString("fr-FR", {style:"currency", currency:"EUR"})
            }
        },
        mixins: [mixin],
        watch: {
            model() {
                this.setPriceInEurosFromModel();
            },
        },
        mounted() {
            this.setPriceInEurosFromModel();
        }
    }
</script>
